import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AbstractFormConstructorComponent } from '../form-constructor-abstract.component';

@Component({
  selector: 'app-form-constructor-profile-base',
  templateUrl: './form-constructor-profile-base.component.html',
})
export class FormConstructorProfileBaseComponent extends AbstractFormConstructorComponent implements AfterViewInit {
  @Output() public formComponentInitiated: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();

  public prepareSubmitData(): void {
    this.getFormValues(this.childForm.form);
  }

  public ngAfterViewInit() {
    this.formComponentInitiated.emit(this.childForm.form);
  }
}
